// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import spfction from './spfction'
import ElementUI from 'element-ui'
import starpostUI from 'starpost-ui'
import VueAMap from 'vue-amap'
import axios from 'axios'
import GlobalJs from '../static/js/globalParams'
import Auth from '../static/js/auth'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/iconfont/iconfont.css'
import '@/assets/scss/public.scss'
import request1 from '@/util/request1'
import { getToken, windowOpen1 } from '@/util/auth'

// 初始化vue-amap
VueAMap.initAMapApiLoader({
  key: '67cbf25aaeeb270f65bf66afaa028cb5',
  plugin: ['Autocomplete', 'PlaceSearch', 'Scale', 'OverView', 'ToolBar', 'MapType', 'PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation', 'Geocoder']
});

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype._logo_ = _logo_
Vue.prototype.company_name = company_name
Vue.prototype.$request1 = request1
Vue.prototype.$getToken = getToken
Vue.prototype.$windowOpen1 = windowOpen1  // 自定义打开窗口


Vue.use(ElementUI)
Vue.use(starpostUI)
Vue.use(spfction)
Vue.use(VueAMap)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js